import TvcMobileComponent from "../../../../src/events/2023/03/tvcMobile/main";
import * as React from 'react';
export default {
  TvcMobileComponent,
  React
};